export const posts = {
    kind: "blogger#postList",
    nextPageToken: "CgkIChiK-NqWxS0Qys2wrtDd95JE",
    items: [
      {
        kind: "blogger#post",
        id: "4452201243226640212",
        blog: {
          id: "4910576078303274698",
        },
        published: "2021-02-09T20:05:00-03:00",
        updated: "2021-02-09T22:21:49-03:00",
        url: "http://dar10comyr.blogspot.com/2021/02/frameworks-los-chapazos-maven-parte-12.html",
        selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/4452201243226640212",
        title: "Frameworks a los chapazos: Maven (Parte 1/2)",
        images: [
          {
            url: "https://1.bp.blogspot.com/-1r3MABehPwU/YCHnW2BZiII/AAAAAAAACjI/ZaETXzUf_KUJv2kSGJeGEkHtWaua2rBqwCLcBGAsYHQ/s0/java-maven.png",
          },
        ],
        author: {
          id: "07261085970826115612",
          displayName: "Dariojz",
          url: "https://www.blogger.com/profile/07261085970826115612",
          image: {
            url: "//3.bp.blogspot.com/-ybX5hP3-8dQ/WRrofPT2DnI/AAAAAAAAA60/RhWH27r8xDMtE9ye1YdWtMDyANgbGjv3QCK4B/s35/WIN_20140717_192226.JPG",
          },
        },
        replies: {
          totalItems: "0",
          selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/4452201243226640212/comments",
        },
        etag: '"dGltZXN0YW1wOiAxNjEyOTIwMTA5NzkwCm9mZnNldDogLTEwODAwMDAwCg"',
      },
      {
        kind: "blogger#post",
        id: "3661487094163829785",
        blog: {
          id: "4910576078303274698",
        },
        published: "2020-08-27T13:05:00-03:00",
        updated: "2020-08-27T13:06:46-03:00",
        url: "http://dar10comyr.blogspot.com/2020/08/principios-en-el-diseno-del-software.html",
        selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/3661487094163829785",
        title: "Principios en el diseño del software: KISS, DRY y SOLID",
        images: [
          {
            url: "https://1.bp.blogspot.com/-oOxDUl2IDjU/X0fZpAH1P1I/AAAAAAAABtY/0X-pf1YpTxwLam1TdCTCPQsfkYZ5XYDcQCLcBGAsYHQ/s320/principios-disenio.png",
          },
        ],
        author: {
          id: "07261085970826115612",
          displayName: "Dariojz",
          url: "https://www.blogger.com/profile/07261085970826115612",
          image: {
            url: "//3.bp.blogspot.com/-ybX5hP3-8dQ/WRrofPT2DnI/AAAAAAAAA60/RhWH27r8xDMtE9ye1YdWtMDyANgbGjv3QCK4B/s35/WIN_20140717_192226.JPG",
          },
        },
        replies: {
          totalItems: "0",
          selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/3661487094163829785/comments",
        },
        labels: ["Principios"],
        etag: '"dGltZXN0YW1wOiAxNTk4NTQ0NDA2ODY4Cm9mZnNldDogLTEwODAwMDAwCg"',
      },
      {
        kind: "blogger#post",
        id: "3294990296814946528",
        blog: {
          id: "4910576078303274698",
        },
        published: "2019-11-05T15:45:00-03:00",
        updated: "2019-12-12T16:59:40-03:00",
        url: "http://dar10comyr.blogspot.com/2019/11/principios-solid.html",
        selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/3294990296814946528",
        title: "Principios SOLID",
        images: [
          {
            url: "https://1.bp.blogspot.com/-IDBQ_TRnL40/XcHDFU5k8NI/AAAAAAAABSw/L584X-iDTDg7uOmBSkUsP8Pgcr9t6hcHgCLcBGAsYHQ/s400/java-solid-principles.png",
          },
        ],
        author: {
          id: "07261085970826115612",
          displayName: "Dariojz",
          url: "https://www.blogger.com/profile/07261085970826115612",
          image: {
            url: "//3.bp.blogspot.com/-ybX5hP3-8dQ/WRrofPT2DnI/AAAAAAAAA60/RhWH27r8xDMtE9ye1YdWtMDyANgbGjv3QCK4B/s35/WIN_20140717_192226.JPG",
          },
        },
        replies: {
          totalItems: "0",
          selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/3294990296814946528/comments",
        },
        labels: ["Principios"],
        etag: '"dGltZXN0YW1wOiAxNTc2MTgwNzgwNTU5Cm9mZnNldDogLTEwODAwMDAwCg"',
      },
      {
        kind: "blogger#post",
        id: "2734123311501810480",
        blog: {
          id: "4910576078303274698",
        },
        published: "2019-12-12T15:53:00-03:00",
        updated: "2019-12-12T16:59:36-03:00",
        url: "http://dar10comyr.blogspot.com/2019/12/principios-acid.html",
        selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/2734123311501810480",
        title: "Principios ACID",
        images: [
          {
            url: "https://4.bp.blogspot.com/-EhKozIzKab8/XfKMbExN-pI/AAAAAAAABU4/eonpKPFFI3wGHkMu9rKzsiuCy7_iL1aHgCLcBGAsYHQ/s400/java-principios-ACID.png",
          },
        ],
        author: {
          id: "07261085970826115612",
          displayName: "Dariojz",
          url: "https://www.blogger.com/profile/07261085970826115612",
          image: {
            url: "//3.bp.blogspot.com/-ybX5hP3-8dQ/WRrofPT2DnI/AAAAAAAAA60/RhWH27r8xDMtE9ye1YdWtMDyANgbGjv3QCK4B/s35/WIN_20140717_192226.JPG",
          },
        },
        replies: {
          totalItems: "0",
          selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/2734123311501810480/comments",
        },
        labels: ["Principios"],
        etag: '"dGltZXN0YW1wOiAxNTc2MTgwNzc2ODM0Cm9mZnNldDogLTEwODAwMDAwCg"',
      },
      {
        kind: "blogger#post",
        id: "1166007870988496007",
        blog: {
          id: "4910576078303274698",
        },
        published: "2019-09-12T12:14:00-03:00",
        updated: "2019-09-12T12:14:47-03:00",
        url: "http://dar10comyr.blogspot.com/2019/09/metodos-generar-codigo-de-barras-y.html",
        selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/1166007870988496007",
        title: "[Métodos] Generar código de barras y Códigos QR - Generación de códigos QR con ZXing",
        images: [
          {
            url: "https://2.bp.blogspot.com/--U5uRZ7047E/XXpcKV_uioI/AAAAAAAABRY/3PJ2F9oi9HQo1DueIFmttelwZZfpWgcwACPcBGAYYCw/s400/java-qrcode.png",
          },
        ],
        author: {
          id: "07261085970826115612",
          displayName: "Dariojz",
          url: "https://www.blogger.com/profile/07261085970826115612",
          image: {
            url: "//3.bp.blogspot.com/-ybX5hP3-8dQ/WRrofPT2DnI/AAAAAAAAA60/RhWH27r8xDMtE9ye1YdWtMDyANgbGjv3QCK4B/s35/WIN_20140717_192226.JPG",
          },
        },
        replies: {
          totalItems: "0",
          selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/1166007870988496007/comments",
        },
        labels: ["misMétodos()"],
        etag: '"dGltZXN0YW1wOiAxNTY4MzAxMjg3MTMxCm9mZnNldDogLTEwODAwMDAwCg"',
      },
      {
        kind: "blogger#post",
        id: "3788321426473857907",
        blog: {
          id: "4910576078303274698",
        },
        published: "2019-09-11T13:14:00-03:00",
        updated: "2019-09-11T13:20:42-03:00",
        url: "http://dar10comyr.blogspot.com/2019/09/metodos-generar-pdf-con-jasper.html",
        selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/3788321426473857907",
        title: "[Métodos] Generar pdf con Jasper",
        images: [
          {
            url: "https://1.bp.blogspot.com/-aIhXyd17ZPc/XXKDfnvIDsI/AAAAAAAABQs/iLYrqB6mfVYpAbRTgFzVI44gvYnP54NWQCLcBGAs/s1600/java-jasper.png",
          },
        ],
        author: {
          id: "07261085970826115612",
          displayName: "Dariojz",
          url: "https://www.blogger.com/profile/07261085970826115612",
          image: {
            url: "//3.bp.blogspot.com/-ybX5hP3-8dQ/WRrofPT2DnI/AAAAAAAAA60/RhWH27r8xDMtE9ye1YdWtMDyANgbGjv3QCK4B/s35/WIN_20140717_192226.JPG",
          },
        },
        replies: {
          totalItems: "0",
          selfLink: "https://content-blogger.googleapis.com/v3/blogs/4910576078303274698/posts/3788321426473857907/comments",
        },
        labels: ["misMétodos()"],
        etag: '"dGltZXN0YW1wOiAxNTY4MjE4ODQyNzA3Cm9mZnNldDogLTEwODAwMDAwCg"',
      }
    ],
    etag: '"MjAyMS0wMi0xMFQxNDoyNDo0OS45OTNa"',
};
